import { APP_ID } from "../config/environment";

const keyFor = (key: string) => `chatoner-academy:${APP_ID}:ui:v1:${key}`;

export function readStorage(key: string) {
  if (typeof window === "undefined") return null;
  try {
    const versioned = window.localStorage.getItem(keyFor(key));
    if (versioned !== null) return versioned;
    const legacy = window.localStorage.getItem(key);
    if (legacy !== null) window.localStorage.setItem(keyFor(key), legacy);
    return legacy;
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(keyFor(key), value);
  } catch {
    // Persistence is optional in restricted and private browsing contexts.
  }
}

export function removeStorage(key: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(keyFor(key));
    window.localStorage.removeItem(key);
  } catch {
    // Nothing else is required when storage is unavailable.
  }
}

export function readStoredJson<T>(key: string, fallback: T): T {
  try {
    const value = readStorage(key);
    return value === null ? fallback : (JSON.parse(value) as T);
  } catch {
    return fallback;
  }
}

export function writeStoredJson(key: string, value: unknown) {
  writeStorage(key, JSON.stringify(value));
}
